const heroBackButton = document.querySelector('.hero--back-button');
if (heroBackButton !== null) {
  heroBackButton.addEventListener('click', () => {
    window.history.go(-1);
  });
}

// Hero Type Homepage slideshow
const heroSlideshow = document.querySelector('.hero--homepage-slideshow');
if (heroSlideshow !== null) {
  const heroSlideshowImages = heroSlideshow.querySelector('.hero--homepage-slideshow-images');
  const slides = heroSlideshowImages.querySelectorAll('.hero--homepage-slideshow-image');
  const navyBoxSlides = heroSlideshow.parentNode.querySelectorAll('.hero--homepage--navy-box');
  const slideCount = slides.length;
  const timeout = 5000;
  let currentSlide = 0;

  const showSlides = () => {
    currentSlide += 1;
    if (currentSlide > slideCount) {
      for (let i = 0; i < slideCount; i += 1) {
        slides[i].classList.remove('hero--homepage-slideshow-image--show');
        navyBoxSlides[i].classList.remove('hero--homepage--navy-box--show');
      }
      currentSlide = 1;
    }
    slides[currentSlide - 1].classList.add('hero--homepage-slideshow-image--show');

    navyBoxSlides[currentSlide - 1].classList.add('hero--homepage--navy-box--show');
    if (currentSlide - 2 >= 0) {
      navyBoxSlides[currentSlide - 2].classList.remove('hero--homepage--navy-box--show');
    }
    if (currentSlide === slideCount) {
      setTimeout(() => {
        for (let i = 0; i < slideCount - 1; i += 1) {
          slides[i].classList.remove('hero--homepage-slideshow-image--show');
          navyBoxSlides[i].classList.remove('hero--homepage--navy-box--show');
        }
      }, 2000);
    }
    setTimeout(showSlides, timeout);
  };

  showSlides();
}
